// @flow
export type State = {};
export const init: State = {};

export default (state: State = init): State => state;
